var MOBILE_WIDTH = 767, TABLET_WIDTH = 1024, GNB_VISIBLE_HEIGHT = 830, IE_VER = msieversion();

$(document).ready(function () {
    //tab_type3
    if ($(".tab_type3").length) {
        tabtype3Init();
    }

    //layerPopup
    if ($(".popup_wrap").length) {
        layerPopupInit();
    }
});

function tabtype3Init() {
    var viewportWidth, lastWindowWidth = 800, lastWindowHeight = 800;
    $(".tab_type3 ul > li > a").on("click", function (e) {
        //e.stopPropagation();
        //e.preventDefault();
        $(".tab_type3 ul > li > a").removeClass("tab_on");
        $(this).addClass("tab_on");
        var str = $(this).text();
        $(".tab_type3 a.input_box > span").text(str);

        if (viewportWidth < MOBILE_WIDTH) {
            if (IE_VER < 9 && IE_VER !== false) {

            } else {
                $(".tab_type3 ul").css("display", "none");
            }
        }
    });
    //히든 텍스트 변경
    //$('.tab_type3').closest('.inner').find('h4.hidden').text($(this).text());

    $(".tab_type3 a.input_box").on("click", function (e) {
        e.stopPropagation();
        e.preventDefault();
        if ($(".tab_type3 ul").css("display") == "none") {
            $(".tab_type3 ul").css("display", "block");
        } else {
            $(".tab_type3 ul").css("display", "none");
        }
    });

    $(window).resize(function () {
        if ($(window).height() != lastWindowHeight || $(window).width() != lastWindowWidth) {
            lastWindowHeight = $(window).height();
            lastWindowWidth = $(window).width();
            tabtype3Resize();
        }
    }).resize();

    function tabtype3Resize() {
        $(".tab_type3 ul").css("display", "");
        document.body.style.overflow = "hidden";
        viewportWidth = $(window).width();
        document.body.style.overflow = "";
    }
}

function layerPopupInit() {
    if ($(".pip_wrap").length) {
        return;
    }
    var viewportWidth, viewportHeight, popupMarginLeft = 30, popupMarginTop = 82;
    var lastWindowHeight = 800;
    var lastWindowWidth = 800;

    $(window).resize(function () {
        if ($(window).height() != lastWindowHeight || $(window).width() != lastWindowWidth) {
            lastWindowHeight = $(window).height();
            lastWindowWidth = $(window).width();
            popupResize();
        }
    }).resize();

    function popupResize() {
        $(".popup_wrap").css({"width": ""});
        document.body.style.overflow = "hidden";
        viewportWidth = $(window).width();
        if ($(window).height() < $(document).height()) {
            viewportHeight = $(document).height();
        } else {
            viewportHeight = $(window).height();
        }
        document.body.style.overflow = "";

        var popWidth = viewportWidth - popupMarginLeft;
        $(".popup_wrap").css({"width": popWidth});
        popupPosSet();
    }

    function popupPosSet() {
        $(".popup_wrap").each(function (i, t) {
            var h1 = $(window).height();
            var h2 = $(this).height();
            var w1 = $(window).width();
            var w2 = $(this).width();
            var popleft = w1 / 2 - w2 / 2 - popupMarginLeft / 2;

            $(this).css({position: "absolute", left: popleft});
        });
    }
}

//internet Explorer version check
function msieversion() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
        return parseInt(ua.substring(msie + 5, ua.indexOf(".", msie)));
    }
    return false;
}
